import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { selectStyles, selectTheme } from "../../../utils/selectUtils/selectUtils";
import styles from "./ChangeExploreLanguages.module.css";
import { useEffect, useState } from "react";
import { api, Api } from "../../../services/Api";
import { setToast } from "../../../redux/actions/appActions";
import { useDispatch } from "react-redux";

const ChangeExploreLanguages: React.FC = () => {
    const dispatch = useDispatch();
    const [isLoadingAllLanguages, setIsLoadingAllLanguages] = useState(true);
    const [isLoadingExploreLanguages, setIsLoadingExploreLanguages] = useState(true);
    const [languages, setLangauges] = useState<Array<{ value: string; label: string }>>();
    const [selectedLanguages, setSelectedLanguages] = useState<Array<{ value: ""; label: "" }>>();
    const { t } = useTranslation();

    const handleLanguagesChange = (languagesFromSelect: any) => {
        setSelectedLanguages(languagesFromSelect);

        const languageIds: (string | null)[] = languagesFromSelect.map((lang: { value: string }) => lang?.value);
        const nonNulllanguageIds: string[] = languageIds.filter((value) => value !== null) as string[];
        const languageIdsString: string = nonNulllanguageIds.join(",");

        const bodyJson = {
            IdsString: languageIdsString,
        };
        Api.put("languages/explore", bodyJson).then((response) => {
            if (response.status === 200) {
                dispatch(setToast({ text: "Explore langauges changed", isPositive: true }));
            } else {
                dispatch(setToast({ text: "Explore langauges not changed", isPositive: true }));
            }
        });
    };

    useEffect(() => {
        api.get("api/languages/all")
            .then((response) => {
                if (response.status !== 200) {
                    console.log("ERROR: can not download langauges");
                }
                return response.data;
            })
            .then((result) => {
                const mappedLanguages = result.map((language: any) => ({
                    value: language.id,
                    label: language.name,
                }));
                setLangauges(mappedLanguages);
                setIsLoadingAllLanguages(false);
            });

        Api.get("languages/explore")
            .then((response) => {
                if (response.status !== 200) {
                    console.log("ERROR: can not download langauges");
                }
                return response.data;
            })
            .then((result) => {
                const mappedLanguages = result.map((language: any) => ({
                    value: language.id,
                    label: language.name,
                }));
                setSelectedLanguages(mappedLanguages);
                setIsLoadingExploreLanguages(false);
            });
    }, []);

    return (
        <div>
            <h5 className="my-3">{t("containers.settingsPage.exploreLanguages")}</h5>
            <Form.Group controlId="languageIds" className="mb-3">
                <Select
                    className={styles.langaugeForm}
                    isSearchable={true}
                    value={selectedLanguages}
                    isMulti
                    name="colors"
                    options={languages}
                    isLoading={isLoadingAllLanguages || isLoadingExploreLanguages}
                    onChange={handleLanguagesChange}
                    styles={selectStyles}
                    theme={selectTheme}
                />
            </Form.Group>
        </div>
    );
};

export default ChangeExploreLanguages;
